// 从原有 src/framework/editor/src/page/index/components/canvas/element-types/table-element/utils.js 中迁移过来
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { mouseType } from '@src/utils/key-mouse-event/mouse-map';

export function isShiftKey(event: MouseEvent): boolean {
    return event.shiftKey;
}

export function isMetaOrShiftOrCtrlKey(event: MouseEvent): boolean {
    return event.metaKey || event.shiftKey || event.ctrlKey;
}

export function isContextMenuEvent(event: MouseEvent): boolean {
    return event.button === mouseType.rightClick || (browser.isMac && event.ctrlKey);
}
